ClientDiversEnteteValidator.$inject = ['validator'];

export default function ClientDiversEnteteValidator(validator) {
	const instance = new validator();
	const telRgx = /(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}/;

	instance.ruleFor('code').notEmpty().when(isNotCodeAuto).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('code').length(1, 100).when(isNotCodeAuto).withMessage('VALIDATION_TOO_LONG_DESCRIPTION');
	instance.ruleFor('libelle').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('mail').emailAddress().when(isCompleted).withMessage('VALIDATION_EMAIL');
	instance.ruleFor('telephone').matches(telRgx).when(isCompleted).withMessage('VALIDATION_PHONE');
	instance.ruleFor('telephoneMobile').matches(telRgx).when(isCompleted).withMessage('VALIDATION_PHONEMOBILE');
	instance.ruleFor('isDematBLSMS').must(checkMobile).when(isCompleted).withMessage('VALIDATION_PHONEMOBILE_MISSING_DEMAT');
	instance.ruleFor('isDematBLMail').must(checkMail).when(isCompleted).withMessage('VALIDATION_EMAIL_MISSING_DEMAT');

	/*instance.ruleFor('telephoneMobile').matches(/(0|\+33)\d{9}/).when(isCompleted).withMessage('VALIDATION_PHONE');
    instance.ruleFor('fax').matches(/(0|\+33)\d{9}/).when(isCompleted).withMessage('VALIDATION_FAX');*/
	return instance;

	function isCompleted(obj, prop) {
		return prop != null && typeof prop !== undefined && prop != '';
	}

	function isNotCodeAuto(obj, prop) {
		return !obj.isCodeAutoEnabled;
	}

	function checkMobile(obj, prop) {
		return !!obj.telephoneMobile;
	}

	function checkMail(obj, prop) {
		return !!obj.mail && obj.mail.trim() !== '';
	}
}
